import { HierarchyChildReadDto } from "functions/api/hierarchy/HierarchyChildReadDto";
import { HierarchyReadDto } from "functions/api/hierarchy/HierarchyReadDto";
import { eHierarchyLevel } from "../../functions/api/enums";
import { HierarchyBackupVersionDto } from "../../functions/api/hierarchy/loadHierarchyVersions";
import { HierarchySearchDto } from "../../functions/api/hierarchy/searchAllHierarchies";

/**
 * Generates the base URL for a hierarchy based on its level and properties.
 *
 * @param hierarchy - The hierarchy object to generate the URL for
 * @param pathName - Optional. The current path name to preserve navigation context
 * @returns The base URL for the hierarchy
 */
export const getHierarchyBaseUrl = (
  hierarchy:
    | HierarchyReadDto
    | HierarchySearchDto
    | HierarchyChildReadDto
    | HierarchyBackupVersionDto
    | {
        hierarchyTag: string;
        isBackupVersion: boolean;
        level: eHierarchyLevel;
        name: string;
        parentTag: string;
        tocMajorVersion?: number;
      },
  pathName?: string,
): string => {
  // Generate the base URL
  let baseUrl: string;
  switch (hierarchy.level) {
    case eHierarchyLevel.TA:
      baseUrl = `/TA/${hierarchy.hierarchyTag}`;
      break;
    case eHierarchyLevel.Project:
      baseUrl = `/Project/${hierarchy.hierarchyTag}`;
      break;
    case eHierarchyLevel.Study:
      baseUrl = `/Study/${hierarchy.hierarchyTag}`;
      break;
    case eHierarchyLevel.Report: {
      if (
        "isBackupVersion" in hierarchy &&
        hierarchy.isBackupVersion === true &&
        hierarchy.tocMajorVersion !== undefined
      ) {
        baseUrl = `/Study/${hierarchy.parentTag}/Report/${hierarchy.name}/Version/${hierarchy.tocMajorVersion}`;
      } else {
        baseUrl = `/Study/${hierarchy.parentTag}/Report/${hierarchy.name}`;
      }
      break;
    }
    case (eHierarchyLevel.Corporate, eHierarchyLevel.TopLevel):
    default:
      baseUrl = "/Corporate";
  }

  // Navigate to the same path as needed.
  if (pathName) {
    const decodedPathName = decodeURIComponent(pathName);

    /* istanbul ignore else */
    if (decodedPathName.startsWith(baseUrl) && decodedPathName.length > baseUrl.length) {
      const remainingPath = decodedPathName.substring(baseUrl.length);
      return `${baseUrl}${remainingPath}`;
    }
  }
  return baseUrl;
};
